import * as React from 'react';
import { HostedWebContentSdkService } from '../Services/hosted-web-content-sdk';
import { IMetaOsHubServices } from '../Services/interfaces';
import {
  AppInitInfo,
  AppInitState,
  IAppDefinition,
  ICommunicationBridge,
  IWebContentContext,
} from '../Services/hosted-web-content-sdk.interface';
import { TelemetrySink } from '@microsoft/oteljs';

export const useCreateAppHostSdk = (
  host: Window,
  context: IWebContentContext,
  hubServices: IMetaOsHubServices,
  appDefinition: IAppDefinition,
  communicationBridge: ICommunicationBridge,
  telemetrySink?: TelemetrySink
) => {
  const [appInitInfo, setAppInitInfo] = React.useState<AppInitInfo>({
    state: AppInitState.Unknown,
  });

  React.useEffect(() => {
    // whenever the appDefinition changes we should reset the appInitState as seen by the Container
    // this way if the previous app failed, we won't prevent the new one from being loaded
    if (appInitInfo.state === AppInitState.Failed) {
      setAppInitInfo({ state: AppInitState.Unknown });
    }
  }, [appDefinition]);

  const appHostSdk = React.useMemo(
    () =>
      new HostedWebContentSdkService(host, communicationBridge, context, hubServices, setAppInitInfo, telemetrySink),
    [host, context.page.frameContext, setAppInitInfo, context.app.host.clientType]
  );

  return { appHostSdk, appInitInfo };
};
